import { change } from "redux-form"
import numeral from "numeral"

export function enableRoundTrip() {
  return (dispatch, getState) => {
    dispatch({ type: "ENABLE_ROUND_TRIP" })
    dispatch(requestDirections())
  }
}
export function disableRoundTrip() {
  return (dispatch, getState) => {
    dispatch({ type: "DISABLE_ROUND_TRIP" })
    dispatch(requestDirections())
  }
}

export function onMapClicked(event) {
  const payload = { lat: event.latLng.lat(), lng: event.latLng.lng() }

  return (dispatch, getState) => {
    // TODO /AutoComplete SELECT_TO extract here and use that to fill autocomplete
    // first check from or to fields are empty...
    // then autocomplete and populate that field ...
    // NOTE some folks zoom in by clicking.
    // From/To select dropdown should have a "Pick on map"

    // const { origin, destination } = getState().map
    // if (!destination) dispatch({
    //   type:'SELECT_TO',
    //   to: payload,
    //   destination: payload,
    //   center: payload,
    // })
    //
    // if (!origin) dispatch({
    //   type:'SELECT_FROM',
    //   from: payload,
    //   origin: payload,
    //   center: payload,
    // })

    dispatch({ type: "MAP_CLICKED", payload })
    // dispatch(requestDirections())
  }
}

function computeTotalDistance(routes) {
  var total = 0
  var myroute = routes[0]
  for (var i = 0; i < myroute.legs.length; i++) {
    total += myroute.legs[i].distance.value
  }
  total = total / 1000
  return total //+ ' km';
}

export function requestDirections() {
  return (dispatch, getState) => {
    const {
      round_trip_enabled,
      calculate_route_enabled
    } = getState().form.trip.values

    // if calculate_route_enabled or round_trip_enabled
    round_trip_enabled
      ? dispatch({ type: "ENABLE_ROUND_TRIP" })
      : dispatch({ type: "DISABLE_ROUND_TRIP" })

    // calculate_route_enabled ? .... do stuff

    const { origin, destination, waypoints } = getState().map
    // if (!calculate_route_enabled) return console.log('calculate route is off')
    if (!origin || !destination)
      return console.log("missing origin or destination")

    // clear the static markers and polyline to make room for directions ui elements
    dispatch({ type: "CLEAR_MAP" })

    // need to set calculate_route_enabled if creating a new trip

    dispatch({ type: "REQUEST_DIRECTIONS", origin, destination, waypoints })

    if (!window.google) {
      console.log("no google. will retry in 1 second")
      return setTimeout(() => dispatch(requestDirections()), 400)
    }
    let DirectionsService = new window.google.maps.DirectionsService()

    const opts = round_trip_enabled
      ? {
          origin,
          destination: origin,
          waypoints: [{ location: destination }],
          travelMode: "DRIVING"
        }
      : {
          origin,
          destination,
          waypoints,
          travelMode: "DRIVING"
        }

    DirectionsService.route(opts, function(response, status) {
      const { routes, geocoded_waypoints } = response
      if (status === "OK") {
        dispatch({ type: "RECEIVE_DIRECTIONS", response })
        dispatch(change("trip", "kms", computeTotalDistance(routes)))
        dispatch(
          change("trip", "miles", computeTotalDistance(routes) * 0.62137119)
        )

        const locations = routes[0].overview_path
          .map(p => p.toJSON())
          .map(p => `${p.lat},${p.lng}`)
        dispatch(change("trip", "locations", locations))
      } else {
        dispatch({ type: "REJECT_DIRECTIONS", status })
        throw new Error("Could not display directions due to: ", status)
      }
    })
  }
}

// export function onDragged(directions) {
export function onDirectionsChanged(directions) {
  return (dispatch, getState) => {
    dispatch({ type: "DIRECTIONS_CHANGED", directions })
    dispatch(change("trip", "kms", computeTotalDistance(directions.routes)))
    dispatch(
      change(
        "trip",
        "miles",
        computeTotalDistance(directions.routes) * 0.62137119
      )
    )
    const locations = directions.routes[0].overview_path
      .map(p => p.toJSON())
      .map(p => `${p.lat},${p.lng}`)
    dispatch(change("trip", "locations", locations))
  }
}

export function getCurrentPosition(label) {
  return (dispatch, getState) => {
    dispatch({ type: "REQUEST_CURRENT_POSITION" })
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const { latitude, longitude } = position.coords
        // TODO set autocomplete bounds
        return dispatch({
          type: "SET_CURRENT_POSITION",
          latitude,
          longitude,
          label
        })
      })
    } else {
      dispatch({ type: "REJECT_CURRENT_POSITION" })
    }
  }
}

//
// export function onSelect(index, option) {
//   console.log(option.props.label)
//   const { label } = option.props
//   return (dispatch, getState) => {
//     // TODO if origin && destination displayRoute(...)
//     const selected = getState().trips.dataSource[index]
//     dispatch({type: 'SELECT_LOCATION', index, selected, label})
//     dispatch(toggleCalculateRoute())
//
//   }
// }
//
// export function onSearch(searchValue) { //aka query
//   return (dispatch, getState) => {
//     if (searchValue.trim()=='') {
//       const places = [{icon_name:'Home', name: 'home', address: '123 fake st'}]
//       return dispatch({type: 'SEARCH_LOCATION', places: Object.values(places), searchValue})
//
//     }
//
//     dispatch({type: 'searching', searchValue})
//     let AutocompleteService = new window.google.maps.places.AutocompleteService
//
//     AutocompleteService.getPlacePredictions({ input: searchValue }, (googleResponse)=>{
//       return dispatch({type: 'SEARCH_LOCATION', googleResponse, searchValue})
//
//     })
//   }
// }



// WEBPACK FOOTER //
// ./src/map/actions.js